import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const order = params.get("order");
  const [token, setToken] = useState(null);
  useEffect(() => {
    if (order) api.post(`/payments/cancel/${order}`).then((r) => setToken(r.data.resume_token || null)).catch(() => {});
  }, [order]);
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen max-w-xl mx-auto px-5 py-24">
      <h1 className="font-display font-bold text-4xl tracking-tight">Payment not completed</h1>
      <p className="mt-3 text-slate-400">No payment was taken. Your registration is saved as unpaid — your place is not secured until payment is complete. We've also emailed you a secure link to finish later.</p>
      {token ? (
        <Link to={`/complete-payment?token=${token}`} className="btn-primary mt-8" data-testid="cancel-complete-payment-link">Complete payment now</Link>
      ) : (
        <Link to="/register" className="btn-primary mt-8" data-testid="cancel-restart-link">Return to registration</Link>
      )}
    </div>
  );
}
